(function () {

  // Récupère le formulaire produit le plus proche d'un élément donné
  function getScope(el) {
    return el.closest('product-form-component') || el.closest('form[data-type="add-to-cart-form"]');
  }

  function getBuilder(scope) {
    return scope.querySelector(".cookie-builder");
  }

  function getVariantInput(scope) {
    return scope.querySelector('input[name="id"]');
  }

  function getMaxCookies(scope) {
    const variantInput = getVariantInput(scope);
    const table = window.cookieBuilderMaxByVariant || {};
    if (variantInput && table[variantInput.value]) {
      return table[variantInput.value];
    }
    return 5;
  }

  function getTotalCookies(builder) {
    let total = 0;
    builder.querySelectorAll(".cookie-quantity").forEach(function (item) {
      total += Number(item.textContent);
    });
    return total;
  }

  function getAddToCartButton(scope) {
    return scope.querySelector('[name="add"]');
  }

  function updateMessage(builder, scope) {
    const message = builder.querySelector(".cookie-builder__message");
    if (!message) return;

    const maxCookies = getMaxCookies(scope);
    const total = getTotalCookies(builder);

    if (total < maxCookies) {
      const missing = maxCookies - total;
      message.textContent =
        "Il manque encore " + missing + " cookie" + (missing > 1 ? "s" : "") + " 🍪";
    } else if (total > maxCookies) {
      const excess = total - maxCookies;
      message.textContent =
        "Retirez " + excess + " cookie" + (excess > 1 ? "s" : "") + ", votre boîte est trop pleine 😅";
    } else {
      message.textContent = "Votre boîte est prête 🤎";
    }
  }

  function updateButtonsState(builder, scope) {
    const maxCookies = getMaxCookies(scope);
    const total = getTotalCookies(builder);
    const isFull = total >= maxCookies;

    builder.querySelectorAll(".cookie-plus").forEach(function (btn) {
      btn.disabled = isFull;
    });
  }

  function updateAddToCartState(builder, scope) {
    const button = getAddToCartButton(scope);
    if (!button) return;

    if (button.dataset.originalDisabled === undefined) {
      button.dataset.originalDisabled = button.disabled ? "true" : "false";
    }

    const maxCookies = getMaxCookies(scope);
    const total = getTotalCookies(builder);
    const isComplete = maxCookies > 0 && total === maxCookies;
    const originallyDisabled = button.dataset.originalDisabled === "true";

    button.disabled = originallyDisabled || !isComplete;
    button.classList.toggle("cookie-builder-incomplete", !isComplete);
  }

  function updateCompositionProperty(builder, scope) {
    const input = scope.querySelector("#cookie-composition-input");
    if (!input) return;

    const parts = [];
    builder.querySelectorAll(".cookie-card").forEach(function (card) {
      const qty = Number(card.querySelector(".cookie-quantity").textContent);
      if (qty > 0) {
        parts.push(qty + "x " + card.dataset.cookieName);
      }
    });

    input.value = parts.join(", ");
  }

  function updateSimpleComposition(scope) {
    const input = scope.querySelector("#cookie-composition-input");
    if (!input) return;

    const variantInput = getVariantInput(scope);
    const table = window.cookieBuilderMaxByVariant || {};
    const capacity = variantInput ? table[variantInput.value] : undefined;

    if (!capacity) {
      input.value = "";
      return;
    }

    if (window.cookieBuilderIsFixed) {
      const names = window.cookieBuilderFixedCookieNames || [];
      if (names.length === 0) {
        input.value = "";
        return;
      }
      const perCookie = capacity / names.length;
      input.value = names.map(function (name) {
        return perCookie + "x " + name;
      }).join(", ");
    } else {
      const title = window.cookieBuilderProductTitle || "";
      input.value = capacity + "x " + title;
    }
  }

  function refresh(scope) {
    const builder = getBuilder(scope);
    if (builder) {
      updateMessage(builder, scope);
      updateAddToCartState(builder, scope);
      updateCompositionProperty(builder, scope);
      updateButtonsState(builder, scope);
    } else {
      updateSimpleComposition(scope);
    }
  }

  function initAll() {
    document.querySelectorAll('product-form-component, form[data-type="add-to-cart-form"]').forEach(function (scope) {
      refresh(scope);
    });
  }

  // Filet de sécurité : on intercepte le clic sur "Ajouter au panier" en phase
  // de capture sur document, ce qui garantit que ce code s'exécute AVANT
  // n'importe quel gestionnaire de clic interne au framework du thème
  // (même si celui-ci ne passe jamais par un vrai événement "submit").
  document.addEventListener("click", function (event) {
    const addButton = event.target.closest('[name="add"]');
    if (!addButton) return;

    const scope = getScope(addButton);
    if (!scope) return;

    refresh(scope);
  }, true); // true = phase de capture

  document.addEventListener("click", function (event) {
    const plus = event.target.closest(".cookie-plus");
    const minus = event.target.closest(".cookie-minus");
    if (!plus && !minus) return;

    const scope = getScope(event.target);
    if (!scope) return;

    const builder = getBuilder(scope);
    if (!builder) return;

    const card = event.target.closest(".cookie-card");
    if (!card || !builder.contains(card)) return;

    const quantity = card.querySelector(".cookie-quantity");
    const maxCookies = getMaxCookies(scope);

    if (plus) {
      const total = getTotalCookies(builder);
      if (total >= maxCookies) return;
      quantity.textContent = Number(quantity.textContent) + 1;
    } else if (minus) {
      const value = Number(quantity.textContent);
      if (value <= 0) return;
      quantity.textContent = value - 1;
    }

    refresh(scope);
  });

  document.addEventListener("change", function (event) {
    if (event.target.matches('input[name="id"]')) {
      const scope = getScope(event.target);
      if (scope) refresh(scope);
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();